
export type ThreadMembershipStatusStatus = typeof ThreadMembershipStatusStatus[keyof typeof ThreadMembershipStatusStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ThreadMembershipStatusStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  BLOCKED: 'BLOCKED',
} as const;
